import { signOut } from "next-auth/react";
import { toast } from "sonner";

// Track error status to prevent duplicates
let isHandlingAuthError = false;
let currentMigrationError = null;

const useErrorHandling = () => {
  const handleError = async (err, showError = true, showAllError = false) => {
    let error = null;

    if (isAxiosError(err)) {
      const apiError = err.response?.data;
      if (err.response) {
        if (err.response.status === 401) {
          if (!isHandlingAuthError) {
            isHandlingAuthError = true;
            toast.error("Unauthenticated");
            showError = false;
            await signOut({ callbackUrl: "/login" });
          } else {
            showError = false;
          }
        } else if (err.response.status === 403) {
          // Page loads (GET) stay quiet; a rejected save/delete must tell the user why.
          if (err.config?.method === "get") showError = false;
        } else if (err.response.status === 404) {
          showError = false;
        }

        if (err.response.status === 422 && apiError?.errors) {
          error = Object.values(apiError.errors)[0]?.[0] || apiError?.message;
        } else {
          error = apiError?.message || "An error occurred";
        }

        if (
          error.includes("Base table or view not found") ||
          (error.includes("Table") && error.includes("doesn't exist"))
        ) {
          if (currentMigrationError !== error) {
            currentMigrationError = error;
            toast.error("Database not connected");
          }
          showError = false;
        }
      } else {
        error = err.message;
      }
    } else {
      error = "An unexpected error occurred";
    }

    if (showError && !showAllError) {
      toast.error(error);
    }
    return error;
  };

  return [handleError];
};

function isAxiosError(err) {
  return err.isAxiosError !== undefined;
}

export default useErrorHandling;
